import React, { useEffect, useState } from 'react';

const learnImages = ['/assets/home.png', '/assets/home1.png', '/assets/home2.png'];
const learnImagesMobile = ['/assets/home_half.png', '/assets/home1_half.png', '/assets/home2_half.png'];
const scribeImages = ['/assets/scribe1.png', '/assets/scribe2.png', '/assets/scribe3.png', '/assets/scribe4repeat.png', '/assets/scribe4.png'];
const scribeImagesMobile = ['/assets/scribe1_half.png', '/assets/scribe2_half.png', '/assets/scribe3_half.png', '/assets/scribe4repeat_half.png'];
const qaImages = ['/assets/qa1.png', '/assets/qa2.png'];
const qaImagesMobile = ['/assets/qa1_half.png', '/assets/qa2_half.png'];
const learnCaptions = ['Impactful articles. Summarised. Filtered for you.', 'All medical and surgical specialities supported.', 'One tap full-text using institutional access.'];
const scribeCaptions = [
  'Stop writing notes. Record the interaction.', 
  '<span style="font-family: Orbitron;">medr</span> automatically generates the note. Print / Copy + Paste via <a href="/login" style="color: white; font-size: 20px; font-weight: bold;">web portal</a>.',       '<span style="font-family: Orbitron;">medr</span> suggests diagnoses and insights based on international guidelines and literature.', 
  'Read literature relevant to the patient in front of you.', 
  ''
];    const qaCaptions = ['Save hours sifting through articles for answers.', 'Credible answers based on credible sources.'];

function slidesFor(activeTab, isMobile) {
  if (activeTab === 'Scribe') return { images: isMobile ? scribeImagesMobile : scribeImages, captions: scribeCaptions };
  if (activeTab === 'Q+A') return { images: isMobile ? qaImagesMobile : qaImages, captions: qaCaptions };
  return { images: isMobile ? learnImagesMobile : learnImages, captions: learnCaptions };
}

export default function TabContent({ activeTab, isMobile, onPulse }) {
  const { images: initialImages, captions: initialCaptions } = slidesFor(activeTab, isMobile);
  // Initialize state with calculated initial values
  const [currentImage, setCurrentImage] = useState(initialImages[0]);
  const [currentCaption, setCurrentCaption] = useState(initialCaptions[0]);
  const [captionKey, setCaptionKey] = useState(0);

  useEffect(() => {
    setCaptionKey(prevKey => prevKey + 1);
  }, [currentCaption]);

  useEffect(() => {
      const { images, captions } = slidesFor(activeTab, isMobile);

      let imageIndex = 0;
      setCurrentImage(images[imageIndex]);
      setCurrentCaption(captions[imageIndex]);
    
      const intervalId = setInterval(() => {
        imageIndex = (imageIndex + 1) % images.length;
        setCurrentImage(images[imageIndex]);
        setCurrentCaption(captions[imageIndex]);
      }, 5000);
    
      return () => clearInterval(intervalId);
    }, [activeTab, isMobile]);

    return (
      <div className="tab-content" style={{ position: 'relative', width: '100%', marginTop: isMobile ? '20%' : '0%', marginBottom: isMobile ? '-200%' : '0%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {activeTab === 'Scribe' && currentImage === '/assets/scribe4.png' ? (
          <>
            <div className="image-container" style={{ position: 'relative', maxWidth:  '40%', textAlign: 'center' }}>
              {/* scribe4.png with lowering animation */}
              <img src="/assets/scribe4.png" alt="Scribe 4" className="main-image" style={{ width: '100%', height: 'auto', marginTop: isMobile ? '20%' : '0', paddingTop: 20, animation: isMobile ? 'fadeOut 1s forwards' : 'lower 1s forwards', zIndex: 2}} />
              {/* scribe5.png with fade-in and scale effect */}
              <img src="/assets/scribe5.png" alt="Scribe 5" className="main-image fadeInScale" onAnimationEnd={() => onPulse(true)} />
            </div>
          </>
        ) : (
          <div className="image-container" style={{ maxWidth: '40%', textAlign: 'center', scale: isMobile ? '2.0' : '1.0' }}>
            <img src={currentImage} alt="Active tab visual" className="main-image" style={{ width: currentImage === '/assets/scribe5.png' ? '120%' : '100%', height: 'auto', paddingTop: 20 }} />
          </div>
        )}
        {(activeTab === 'Q+A' || activeTab === 'Scribe' || activeTab === 'Learn') && <QATextBox />}
        <div className="caption-container" key={captionKey} style={{
      marginTop: isMobile ? '75%' : '0', 
      textAlign: isMobile ? 'center' : 'left', // Center align text on mobile
      width: isMobile ? '80%' : '260px', // Adjust width for mobile
      position: isMobile ? 'absolute' : 'absolute',
      right: isMobile ? '20' : '100px',
      top: isMobile ? '5%' : '25%',
      marginBottom: isMobile? '20px' : '0',
      paddingLeft: isMobile ? '0' : '-200px',
      color: 'white',
      fontFamily: 'Arial',
      fontSize: '20px',
      letterSpacing: 1.2,
      overflow: 'hidden',
      animation: isMobile ? 'fadeIn 1s ease-out forwards' : 'fadeInLeft 1s ease-out forwards'
    }}>
        <p dangerouslySetInnerHTML={{ __html: currentCaption }}></p>

    </div>
      </div>
    );
}

function QATextBox() {
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [sources, setSources] = useState([]);
  const [isLoading, setIsLoading] = useState(false); // State to track loading status
  const [errorMessage, setErrorMessage] = useState('');

  const handleQuestionChange = (event) => {
    setQuestion(event.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Set loading to true when the request starts
    setErrorMessage('');
    setAnswer('');
    setSources([]);
    try {
      const response = await fetch('https://api.medr.ai/query', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ question }),
      });
      if (!response.ok) throw new Error('Question request failed');
      const data = await response.json();
      if (typeof data.Answer !== 'string' || !Array.isArray(data.Sources) ||
          !data.Sources.every(source => typeof source === 'string')) {
        throw new Error('Invalid question response');
      }
      setAnswer(data.Answer);
      setSources(data.Sources);
    } catch {
      setErrorMessage('Unable to get an answer. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const getSourceUrl = (filename) => {
    let displayText = filename.split('/').pop().split('.')[0].replace(/-/g, ' ');
    if (displayText.includes('pdf')) {
      displayText = displayText.split('pdf')[0];
    }
    displayText = displayText.charAt(0).toUpperCase() + displayText.slice(1);
    let iconUrl = '';

    if (filename.startsWith('medsafePDFs')) {
      iconUrl = 'https://firebasestorage.googleapis.com/v0/b/resurg-62b32.appspot.com/o/medsafe.png?alt=media&token=08db8ee6-55d4-46e9-ba08-61850a488479';
      const drugName = filename.split('/')[1].split('.')[0];
      return {
        url: `https://www.medsafe.govt.nz/profs/datasheet/${drugName.charAt(0)}/${filename.split('/')[1]}`,
        text: displayText,
        icon: iconUrl
      };
    } else if (filename.startsWith('nicePDFs')) {
      iconUrl = 'https://firebasestorage.googleapis.com/v0/b/resurg-62b32.appspot.com/o/nice.png?alt=media&token=0e7437c3-1b2a-4f5b-84e3-f62a5c18127f';
      const searchTerm = filename.split('-').slice(3).join(' ');
      return {
        url: `https://www.nice.org.uk/search?q=${encodeURIComponent(searchTerm)}`,
        text: displayText,
        icon: iconUrl
      };
    } else if (filename.startsWith('https://bpac.org.nz')) {
      iconUrl = 'https://firebasestorage.googleapis.com/v0/b/resurg-62b32.appspot.com/o/bpac3.png?alt=media&token=e002c6c4-f5b5-4f15-9b58-24b8bec9d25d';
      displayText = filename.split('/')[filename.split('/').length - 1].split('.')[0];
      return {
        url: filename,
        text: displayText,
        icon: iconUrl
      };
    } else {
      iconUrl = 'https://firebasestorage.googleapis.com/v0/b/resurg-62b32.appspot.com/o/pubmed.png?alt=media&token=97def8cc-73d8-4d08-873b-a810be4d9a82';
      const searchTerm = filename.replace(/\s/g, '+');
      return {
        url: `https://pubmed.ncbi.nlm.nih.gov/?term=${searchTerm}`,
        text: filename,
        icon: iconUrl
      };
    }
  };

  return (
    <div className="qa-text-box">
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={question}
          onChange={handleQuestionChange}
          placeholder="Enter a medical question"
        />
        <button type="submit" aria-label="Ask question" disabled={isLoading}>
        {isLoading ? (
          <svg className="spinner" viewBox="0 0 50 50">
            <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
          </svg>
        ) : 'Ask'}
      </button>
      </form>
      {errorMessage && <p role="alert">{errorMessage}</p>}
      {answer && (
        <div className="qa-answer">
          <p>{answer}</p>
          <div>
            {sources.map((source, index) => {
              const { url, text, icon } = getSourceUrl(source);
              return (
                <p key={index}>
                  <a href={url} target="_blank" rel="noopener noreferrer">
                    {icon && <img src={icon} alt="Source icon" style={{ width: '16px', verticalAlign: 'middle', marginRight: '5px' }} />}
                    {text}
                  </a>
                </p>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
